import React from 'react'
import { useNavigate } from 'react-router-dom';
interface StepCardProps {
    number: string,
    title: string,
    text: string,
    src: string,
    invested?: boolean,
    color: string,
    link: string
}
export const StepCard: React.FC<StepCardProps> = ({ number, title, text, src, color, invested, link }) => {
    const navigate = useNavigate();
    const handleLink = () => {
        if (link.startsWith('/')) {
            if (link.includes('#')) {
                window.location.href = link;
            } else {
                navigate(link);
            }
        } else {
            window.open(link, '_blank');
        }
    }
    return (
        <div className={`mt-16 flex w-full min-h-[190px] ${invested && 'flex-row-reverse'}`}>
            <div className='hidden w-[20%] md:flex justify-center items-center'>
                <img src={src} alt="Register" />
            </div>
            <div className={`flex flex-col justify-center w-full md:w-[80%] ${color} px-5 rounded-3xl`}>
                <h2 onClick={handleLink} className='cursor-pointer primaryFont text-3xl md:text-5xl font-semibold '>{number} &nbsp;<span className='underline' style={{ textDecorationThickness: '1.5px', textUnderlineOffset: '3px' }}>{title}</span></h2>
                <p className='mt-3 secondaryFont text-[#575757] text-xl md:text-3xl'>{text}</p>
            </div>
        </div>
    )
}
